module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_nara-17d0e17f8b07e7c6d49f81eb63722ee1.jpg";